export const URLS_API = {
	AUTH_LOGIN: '/auth/login',
	AUTH_LOGOUT: '/auth/logout',
	AUTH_CURRENT: '/auth/current',
	ZEPP_SETTINGS: '/zepp/settings',
	ZEPP_SYNC: '/zepp/sync',
	TARGETS: '/targets',
	TARGETS_CURRENT: '/targets/current',
	TARGETS_ITEM: '/targets/:targetId',
	WEIGHT_LOG: '/weight_log',
	WEIGHT_LOG_ITEM: '/weight_log/:id',
	STEPS_LOG: '/steps_log',
	STEPS_LOG_ITEM: '/steps_log/:id',
	BODY_DIMENSIONS_LOG: '/body_dimensions_log',
	BODY_DIMENSIONS_LOG_ITEM: '/body_dimensions_log/:id',
	PHOTO_LOG: '/photo_log',
	PHOTO_LOG_ITEM: '/photo_log/:id',
	MENU: '/menu',
	MENU_ITEM: '/menu/:id',
	MENU_CATALOG: '/menu_catalog',
	MENU_CATALOG_ITEM: '/menu_catalog/:id',
};
